export const btnUtils = {
  loadingToggle: (btn: HTMLButtonElement | HTMLAnchorElement | HTMLElement) => {
    if (btn) {
      if (!btn.classList.contains("rec-is-loading")) {
        btn.setAttribute("data-default-text", btn.innerHTML);
        btn.innerHTML = `<div class="rec-flex rec-justify-center rec-items-center">
                        <?xml version="1.0" ?><svg class="rec-animate-spin" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 10.4142 3.16421 10.75 2.75 10.75C2.33579 10.75 2 10.4142 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C9.58579 18 9.25 17.6642 9.25 17.25C9.25 16.8358 9.58579 16.5 10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5Z" fill="#212121"/></svg>
                      </div>`;
      }
      btn.classList.toggle("rec-is-loading");
      btn.classList.add("disabled");
      if (btn instanceof HTMLButtonElement) {
        btn.disabled = true;
      }
    }
  },

  reset: () => {
    document.querySelectorAll(".rec-is-loading").forEach((thisLoadingElem) => {
      if (thisLoadingElem.classList.contains("rec-is-loading")) {
        const defaultText = thisLoadingElem.getAttribute("data-default-text");
        thisLoadingElem.innerHTML = defaultText !== null ? defaultText : "";
      }
      thisLoadingElem.classList.remove("rec-is-loading");
      thisLoadingElem.classList.remove("disabled");

      // Cast thisLoadingElem to HTMLButtonElement or HTMLInputElement
      if (thisLoadingElem instanceof HTMLButtonElement || thisLoadingElem instanceof HTMLInputElement) {
        thisLoadingElem.disabled = false;
      }
    });
  },
};

/* Is Mobile? */
export const isMobileCheck = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent);
  return check;
};

export const isObject = (obj: unknown) => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};

/* Toasts Utility */
export const makeToast = (toastId: string) => {
  const toastELem = document.getElementById(toastId);
  if (toastELem) {
    toastELem.classList.remove("rec-hidden");
    const url = new URL(window.location.href);
    const currentQueryString = new URLSearchParams(window.location.search);
    currentQueryString.delete("t");
    window.history.pushState(
      {},
      "",
      `${url.pathname}?${currentQueryString.toString()}`
    );
    window.setTimeout(function () {
      toastELem.classList.add("rec-hidden");
    }, 4000);
  } else {
    console.error(`Element with ID ${toastId} not found.`);
  }
};

/**
 * Validates that the seller listing form has the required number of images.
 * @param {HTMLFormElement} sellerListingForm - The form element containing the seller listing information.
 * @param {number} qtyOverride - An optional quantity override for the minimum number of images required.
 * @returns {boolean} Returns true if the form meets the image requirements, otherwise false.
 */
export const sellingListingValidateImages = (
  sellerListingForm: HTMLFormElement,
  qtyOverride: number,
) => {
  // TODO: reverse-eng this form to generate a better type. This was originally written in JS.
  let formData: Record<string, any> = serializeForm(sellerListingForm);
  const minQty =
    qtyOverride >= 0
      ? qtyOverride
      : recAppProxyConfig.settings.slf.seller_images_min;

  // Check/append images
  let listingImageKeys: (string | null)[] = [];
  sellerListingForm
    .querySelectorAll(".rec-slf-entry .dz-preview")
    .forEach((thisPreviewElem) => {
      const imageKey = thisPreviewElem.getAttribute("data-image-key");
      listingImageKeys.push(imageKey);
    });

  if (
    listingImageKeys.length < minQty &&
    ["draft", "patch_draft"].indexOf(formData.action_type) < 0
  ) {
    makeToast("toast-slf-images");
    btnUtils.reset();
    const imageValidationError = sellerListingForm.querySelector(
      ".rec-slf-listing-error-images",
    ) as HTMLDivElement | null;
    if (imageValidationError) {
      imageValidationError.style.display = "block";
    }
    return false;
  }

  return true;
};

/**
 * Serializes form data into an object.
 * @param {HTMLFormElement} form - The form element to serialize.
 * @returns {Record<string, any>} The serialized form data as an object.
 */
export const serializeArray = function (form: HTMLFormElement | HTMLDivElement) {
  // Setup our serialized data
  let serialized: Record<string, any> = {};

  // Loop through each field in the form
  form
    .querySelectorAll("input, select, checkbox, textarea, button")
    .forEach((element) => {
      const field = element as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | HTMLButtonElement;
      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (
        !field.name ||
        field.disabled ||
        field.type === "file" ||
        field.type === "reset" ||
        field.type === "submit" ||
        field.type === "button"
      ) {
        // DO NOTHING
      } else {
        // If a multi-select, get all selections
        if (field instanceof HTMLSelectElement) {
          for (var n = 0; n < field.options.length; n++) {
            if (!field.options[n].selected) continue;
            serialized[field.name] = field.options[n].value;
          }
        }

        // Convert field data to a query string
        else if (
          (field instanceof HTMLInputElement && (field.type !== "checkbox" && field.type !== "radio")) ||
          (field instanceof HTMLInputElement && field.checked)
        ) {
          serialized[field.name] = field.value;
        }
      }
    });

  return serialized;
};

/**
 * Serializes form data into an object.
 * @param {HTMLFormElement} form - The form element to serialize.
 * @returns {Record<string, any>} The serialized form data as an object.
 */
export const serializeForm = function (form: HTMLFormElement) {
  let obj: Record<string, any> = {};
  const formData = new FormData(form);
  // @ts-expect-error: You might see an error here on .entries() depending on your TS config. The method does in fact exist: https://developer.mozilla.org/en-US/docs/Web/API/FormData/entries
  for (let pair of formData.entries()) {
    if (pair[0] in obj) {
      obj[pair[0]] += "," + pair[1];
    } else {
      obj[pair[0]] = pair[1];
    }
  }
  return obj;
};

/**
 * Simulates a click event on the specified HTML element.
 * @param {HTMLElement} elem - The HTML element to simulate the click event on.
 */
export const simulateClick = (elem: HTMLButtonElement) => {
  let evt = new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window,
  });
  let canceled = !elem.dispatchEvent(evt);
};

/**
 * Converts a string to a URL-friendly format by replacing non-alphanumeric characters with hyphens.
 * Optionally appends a random integer to the end of the string.
 * @param {string} str - The string to be converted.
 * @param {boolean} [appendRandom] - Whether to append a random integer to the end of the string.
 * @returns {string} The URL-friendly formatted string.
 */
export const stringHandle = function (str: string, appendRandom?: boolean) {
  let newStr = str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-$/, "")
    .replace(/^-/, "");
  return appendRandom
    ? newStr + "-" + randomIntFromInterval(1000, 10000000)
    : newStr;
};

function randomIntFromInterval(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
